import CrudRepository from './CrudRepository'
export default class FaqCategoryRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/faqCategory/all')
  }
}
